import { UserRegionCreatableInterface } from '../interfaces/user-region-creatable.interface';
import { UserRegionDto } from './user-region.dto';
import { IntersectionType, PartialType, PickType } from '@nestjs/swagger';

export class UserRegionCreateDto
  extends IntersectionType(
    PickType(UserRegionDto, ['userId', 'regionId']),
    PartialType(PickType(UserRegionDto, ['managerUserId'])),
  )
  implements UserRegionCreatableInterface {}
